import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import ReactSelect from 'react-select';
import { Link } from 'react-router-dom';

const DEFAULT_FORM = {
    segmentId: "",
    description: ""
}

const DescriptionSegment = () => {

    const [form, setForm] = useState(DEFAULT_FORM)

    const { addData: addConfig } = useEntityCrud("Config/update")
    const { readData: readDataSegments } = useEntityCrud('Info/getSegments');
    const { readData: readDataSegmentsData } = useEntityCrud('Info/getSegmentData');
    const { readData } = useEntityCrud('Config/get');
    const [segmentList, setSegmentList] = useState([]);
    const [segmentsData, setSegmentsData] = useState([]);
    const [isActive, setIsActive] = useState("");
    const [segmentId, setSegmentId] = useState("");

    const [sportCulture, setSportCulture] = useState({});
    const [food, setFood] = useState({});
    const [editMode, setEditMode] = useState(false);




    useEffect(() => {
        getData();
        debugger
        readData({ "key": "segment_sportculture" }).then(({ data }) => {
            debugger
            if (data.status) {
                setSportCulture(data.result)
            }
        });

        readData({ "key": "segment_food" }).then(({ data }) => {
            if (data.status) {
                setFood(data.result)
            }
        });


    }, []);


    const getData = () => {
        readDataSegments().then(({ data }) => {
            if (data.status)
                setSegmentList(data.result.map(item => ({ label: item.title, value: item.key })))
        });
        readDataSegmentsData().then(({ data }) => {
            if (data.status)
                setSegmentsData(data.result)
        });

    }


    const handleChange = (e) => {
        const newForm = { ...form };
        newForm[e.target.name] = e.target.value
        setForm(newForm)
    }

    function handleSubmit(e) {
        debugger
        e.preventDefault();
        const body = {
            "value": form.description,
            "key": segmentId.value,
        }
        addConfig(body)
            .then(({ data }) => {
                if (data.status) {
                    toast.success('عملیات مورد نظر با موفقیت انجام شد');
                    setForm({ description: "" })
                    setSegmentId("")
                    getData()
                } else
                    toast.error(data.message);
            })
    }



    const deActiveRow = text => {
        const postedData = {
            key: text,
            value: "0"
        };
        addConfig(postedData).then(({ data }) => {
            if (data.status) {
                toast.success('وضعیت مورد نظر با موفقیت به روزرسانی شد');
                readData({ "key": "segment_sportculture" }).then(({ data }) => {
                    debugger
                    if (data.status) {
                        setSportCulture(data.result)
                    }
                });

                readData({ "key": "segment_food" }).then(({ data }) => {
                    if (data.status) {
                        setFood(data.result)
                    }
                });
            } else
                data.errors.map(error => toast.error(error.message));
        });
    }

    const activeRow = text => {
        debugger
        const postedData = {
            key: text,
            value: "1"
        };
        addConfig(postedData).then(({ data }) => {
            debugger
            if (data.status) {
                toast.success('وضعیت مورد نظر با موفقیت به روزرسانی شد');
                readData({ "key": "segment_sportculture" }).then(({ data }) => {
                    debugger
                    if (data.status) {
                        setSportCulture(data.result)
                    }
                });

                readData({ "key": "segment_food" }).then(({ data }) => {
                    if (data.status) {
                        setFood(data.result)
                    }
                });

            } else
                data.errors.map(error => toast.error(error.message));
        });
    }

    return (
        <div className="card">
            <div className="card-header"><div className="card-title">اعتبار ها</div></div>
            <div className="card-body">
            {editMode && <div className="baseInfo_" >
                <form onSubmit={handleSubmit} >
                    <div className='row mx-auto' style={{ display: "flex", alignItems: "end" }}>
                        <div className="col-md-12 pr-0">
                            <div className="form-group">
                                <label>  انتخاب اعتبار     </label>
                                <ReactSelect
                                    required
                                    isDisabled={true}
                                    placeholder="انتخاب کنید"
                                    options={segmentList}
                                    name="segmentId"
                                    isSearchable={true}
                                    value={segmentId}
                                    isRtl={true}
                                    onChange={e => setSegmentId(e)}
                                    noOptionsMessage={() => 'نام مورد نظر یافت نشد'}
                                />
                            </div>
                        </div>

                        {/*          {(segmentId.value === "both" || segmentId.value === "food") &&
                            <div className="col-md-3 pr-0">
                                <div className="form-group">
                                    <label>    وضعیت     </label>
                                    <ReactSelect
                                        required
                                        placeholder="انتخاب کنید"
                                        options={[{ value: "1", label: "فعال" }, { value: "0", label: "غیرفعال" }]}
                                        name="isActive"
                                        isSearchable={true}
                                        value={isActive}
                                        isRtl={true}
                                        onChange={e => {
                                            setIsActive(e)
                                        }
                                        }
                                        noOptionsMessage={() => 'نام مورد نظر یافت نشد'}
                                    />
                                </div>
                            </div>} */}

                        <div className="col-md-12 pr-0">
                            <div className="form-group">
                                <label>  توضیحات  </label>
                                <textarea value={form.description} name={"description"} onChange={handleChange} type="text"
                                    className="form-control mt-0" />
                            </div>
                        </div>
                        <div className="col-md-12 mt-1">
                            <div className="form-group mb-0">
                                <button className="btn btn-success px-4 btn-block" disabled={form.segment !== "" && form.description !== "" ? false : true}>ذخیره اطلاعات </button>
                            </div>
                        </div>
                    </div>ّ
                </form >
                <hr className="mt-4" />
            </div >
            }



            <div class="my-4">
 

                <div className="card-body bg-white" >
                    <table className="table table-bordered table-hover border text-nowrap text-md-nowrap">
                        <thead>
                            <tr>
                                <th>ردیف</th>
                                <th>اعتبار</th>
                                <th>توضیحات      </th>
                                {/*       <th>وضعیت      </th> */}
                                <th>عملیات</th>
                            </tr>
                        </thead>
                        <tbody>
                            {segmentsData?.map((item, i) =>
                                <tr>
                                    <td style={{ width: "1%", textAlign: "center" }}> {i + 1}  </td>
                                    <td> {item.title} </td>
                                    <td> {item.description} </td>
                                    {/*                  <td> {item.status === true ? "فعال" : "غیرفعال"} </td> */}
                                    <td className='iconBTN_ d-flex'>
                                        <button className="btn btn-icon btn-primary py-1  ml-2" title="ویرایش"
                                            onClick={() => {
                                                setSegmentId({ label: item.title, value: item.key })
                                                setForm({ description: item.description })
                                                setEditMode(true)
                                            }}>
                                            <i className="fe fe-edit-2"></i>
                                        </button>

                                        {/*              {item.status === true ?
                                            <button className='btn btn-danger btn-icon mx-1 py-1  ml-2'
                                                onClick={e => deActiveRow(item.key)} >
                                                <i className="fe fe-x  text-white"></i>
                                            </button>
                                            :
                                            <button className='btn btn-success btn-icon mx-1 py-1  ml-2'
                                                onClick={e => activeRow(item.key)} >
                                                <i className="fe fe-check  text-white"></i>
                                            </button>
                                        } */}

                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

            </div>



            <div class="my-4 pt-4">

                <div class="alert alert-danger mt-4" role="alert">
                    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-hidden="true">×</button>
                    <i class="fa fa-bell me-2" aria-hidden="true">
                    </i>
                    دو بخش زیر را می توانید فعال و یا غیر فعال نمایید.
                </div>

                <div className="card-body bg-white" >
                    <table className="table table-bordered table-hover border text-nowrap text-md-nowrap">
                        <thead>
                            <tr>
                                <th>ردیف</th>
                                <th>اعتبار</th>
                                <th>وضعیت      </th>
                                <th>عملیات</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={{ width: "1%", textAlign: "center" }}> 1  </td>
                                <td> 	فرهنگی ورزشی </td>
                                <td>  {sportCulture?.value === "1" ? "فعال" : " غیر فعال "} </td>
                                <td className='iconBTN_ d-flex'>
                                    {sportCulture?.value === "1" ?
                                        <button onClick={e => deActiveRow("segment_sportculture")}
                                            className="btn btn-icon mb-0 btn-danger">
                                            <i className="fe fe-x"></i></button>
                                        : <button onClick={e => activeRow("segment_sportculture")}
                                            className="btn btn-icon mb-0 btn-success">
                                            <i className="fe fe-check"></i></button>}
                                </td>
                            </tr>
                            <tr>
                                <td style={{ width: "1%", textAlign: "center" }}> 2 </td>
                                <td>رستوران </td>
                                <td> {food?.value === "1" ? "فعال" : " غیر فعال "}  </td>
                                <td className='iconBTN_ d-flex'>
                                    {food?.value === "1" ?
                                        <button onClick={e => deActiveRow("segment_food")}
                                            className="btn btn-icon mb-0 btn-danger">
                                            <i className="fe fe-x"></i></button>
                                        : <button onClick={e => activeRow("segment_food")}
                                            className="btn btn-icon mb-0 btn-success">
                                            <i className="fe fe-check"></i></button>}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>
        </div>
    </div>

    );
};


export default DescriptionSegment;